import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/contexts/auth/useAuth";
import { Lock, LogOut, User } from "lucide-react";
import { useNavigate } from "react-router";

export function FrontEndUserMenu() {
    const { user, session } = useAuth();
    const navigate = useNavigate();

    if (!user) return null;

    const initials =
        `${user.first_name?.[0] ?? ""}${user.last_name?.[0] ?? ""}`.toUpperCase() ||
        "U";
    const fullName = `${user.first_name} ${user.last_name}`.trim();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger className="ring-offset-background focus-visible:ring-ring rounded-full outline-none focus-visible:ring-2 focus-visible:ring-offset-2">
                <Avatar className="size-8 cursor-pointer transition-opacity hover:opacity-80">
                    <AvatarFallback className="bg-primary text-primary-foreground text-xs font-medium">
                        {initials}
                    </AvatarFallback>
                </Avatar>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuGroup>
                    <DropdownMenuLabel className="font-normal">
                        <div className="flex flex-col gap-1">
                            <p className="text-sm font-medium">{fullName}</p>
                            <p className="text-muted-foreground text-xs">
                                {user.email}
                            </p>
                        </div>
                    </DropdownMenuLabel>
                </DropdownMenuGroup>
                <DropdownMenuSeparator />
                <DropdownMenuGroup>
                    <DropdownMenuItem
                        onClick={() =>
                            navigate("/organizations/settings/account")
                        }
                    >
                        <User className="mr-2 size-4" />
                        Account
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        onClick={() =>
                            navigate("/organizations/settings/security")
                        }
                    >
                        <Lock className="mr-2 size-4" />
                        Security
                    </DropdownMenuItem>
                </DropdownMenuGroup>
                <DropdownMenuSeparator />
                <DropdownMenuGroup>
                    <DropdownMenuItem onClick={() => session.end()}>
                        <LogOut className="mr-2 size-4" />
                        Sign out
                    </DropdownMenuItem>
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
